import { useEffect, useState } from "react"
import { TableDataV2 } from "@/components/common/Tablev2"
import { Protected } from "@/components/layout/Protected"
import { Autocomplete, Box, Button, Container, Grid, TextField, Typography } from "@mui/material"
import { Loading } from "@/components/common/Loading"
import { CountryService } from "@/service/services/Country.service"
import { Props } from "./District.type"
import { ModalCountryDistrict } from "@/components/Modal/ModalCountryDistrict/ModalCountryDistrict"
import { ModalCountryDistrictDelete } from "@/components/Modal/ModalCountryDistrictDelete/ModalCountryDistrictDelete"

export const DistrictView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [districts, setDistricts] = useState<any>([]);
    const [showdistrictModal, setShowDistrictModal] = useState<boolean>(false);
    const [showDistrictDeleteModal, setShowDistrictDeleteModal] = useState<boolean>(false);
    const [districtSelected, setDistrictSelected] = useState<any>('');
    const [actionSelected, setActionSelected] = useState<any>('');

    const [countries, setCountries] = useState<any>([]);
    const [countrySelected, setCountrySelected] = useState<any>('');
    const [departaments, setDepartaments] = useState<any>([]);
    const [departamentSelected, setDepartamentSelected] = useState<any>('');
    const [provinces, setProvinces] = useState<any>([]);
    const [provinceSelected, setProvinceSelected] = useState<any>('');
    

    useEffect(() => {
        getCountries();
    }, []);

    useEffect(() => {
        if(countrySelected) getDepartments(countrySelected.id);
    }, [countrySelected]);

    const getCountries = async () => {
        setLoading(true);
        await CountryService.getCountries().then((data) => {
            setCountries(data.data || []);
            setCountrySelected(data.data[0] || '');
           setLoading(false);
        });
    }

    const getDepartments = async (idCountry) => {
        setLoading(true);
        await CountryService.getDepartments(idCountry).then((data) => {
            setDepartaments(data.data || [])
           setLoading(false);
        });
    }

    const getProvinces = async (idDepartament) => {
        setLoading(true);
        await CountryService.getProvinces(idDepartament).then((data) => {
            setProvinces(data.data || [])
           setLoading(false);
        });
    }

    const getDistricts = async (idProvince) => {
        setLoading(true);
        await CountryService.getDistricts(idProvince).then((data) => {
            setDistricts(data.data || [])
           setLoading(false);
        });
    }

    function RecuperarData(value){
        setDistrictSelected(value)
        console.log(value)
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container>
                <Grid item xs={12} container direction={'row'} justifyContent='space-between' alignItems={'center'} sx={{marginLeft:'25px'}}>
                    <Grid item container direction={'row'} xs={10} spacing={2} >
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                            id="disable-portal"
                            disablePortal
                            value={countrySelected}
                            options={countries || []}
                            getOptionLabel={(option) => option.name || ""}
                            fullWidth
                            renderInput={(params) => <TextField {...params} variant="standard" label="filtrar por países" />}
                            onChange={(e, newValue) => {
                                if (newValue) {
                                    setCountrySelected(newValue);
                                    newValue && getDepartments(newValue.id);
                                }
                            }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                id="disable-portal"
                                disablePortal
                                value={departamentSelected}
                                options={departaments || []}
                                getOptionLabel={(option) => option.name || ""}
                                fullWidth
                                renderInput={(params) => <TextField {...params} variant="standard" label="filtrar por departamentos" />}
                                onChange={(e, newValue) => { 
                                    setDepartamentSelected(newValue); 
                                    newValue && getProvinces(newValue?.id);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                id="disable-portal"
                                disablePortal
                                value={provinceSelected}
                                options={provinces || []}
                                getOptionLabel={(option) => option.name || ""}
                                fullWidth
                                renderInput={(params) => <TextField {...params} variant="standard" label="filtrar por provincias" />}
                                onChange={(e, newValue) => { 
                                    setProvinceSelected(newValue);
                                    newValue && getDistricts(newValue?.id); 
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <TableDataV2
                    title={'Comunas'}
                    data={districts || []}
                    header={[
                        { name: 'code', label: 'Código', filter: false, Chip: false },
                        { name: 'name', label: 'Nombre', filter: false, Chip: false },
                    ]}
                    actionSelect={setActionSelected}
                    setModalSave={setShowDistrictModal}
                    setModalDelete={setShowDistrictDeleteModal}
                    status_action
                    RecuperarData={RecuperarData}
                />
            </Container>

            { 
                showdistrictModal && (
                    <ModalCountryDistrict
                        open={showdistrictModal}
                        closeModal={()=>{setShowDistrictModal(false)}}
                        actionSelected={actionSelected}
                        onListDistrict={getDistricts}
                        district={districtSelected}
                        clearState={()=>{setDistrictSelected('')}}
                        provinceSelected={provinceSelected}
                    />
                )
            }
            {
                actionSelected === 'delete' && (
                    <ModalCountryDistrictDelete
                        open={showDistrictDeleteModal}
                        closeModal={()=>{setShowDistrictDeleteModal(false)}}
                        actionSelected={actionSelected}
                        onListDistrict={getDistricts}
                        district={districtSelected}
                        clearState={()=>{setDistrictSelected('')}}
                        provinceSelected={provinceSelected}
                    />
                )
            }
        </Protected>
    )
}